__turbopack_context__.v({
  "actionArrow": "ProductPreview-module__2WJK9q__actionArrow",
  "aiAction": "ProductPreview-module__2WJK9q__aiAction",
  "aiFloat": "ProductPreview-module__2WJK9q__aiFloat",
  "aiFloatDot": "ProductPreview-module__2WJK9q__aiFloatDot",
  "aiHeader": "ProductPreview-module__2WJK9q__aiHeader",
  "aiIcon": "ProductPreview-module__2WJK9q__aiIcon",
  "aiPanel": "ProductPreview-module__2WJK9q__aiPanel",
  "app": "ProductPreview-module__2WJK9q__app",
  "avatar": "ProductPreview-module__2WJK9q__avatar",
  "bottomRow": "ProductPreview-module__2WJK9q__bottomRow",
  "brand": "ProductPreview-module__2WJK9q__brand",
  "browserAddress": "ProductPreview-module__2WJK9q__browserAddress",
  "browserBar": "ProductPreview-module__2WJK9q__browserBar",
  "browserLights": "ProductPreview-module__2WJK9q__browserLights",
  "browserMeta": "ProductPreview-module__2WJK9q__browserMeta",
  "chart": "ProductPreview-module__2WJK9q__chart",
  "chartLine": "ProductPreview-module__2WJK9q__chartLine",
  "chevron": "ProductPreview-module__2WJK9q__chevron",
  "content": "ProductPreview-module__2WJK9q__content",
  "delta": "ProductPreview-module__2WJK9q__delta",
  "eyebrow": "ProductPreview-module__2WJK9q__eyebrow",
  "floatOne": "ProductPreview-module__2WJK9q__floatOne",
  "floatThree": "ProductPreview-module__2WJK9q__floatThree",
  "floatTwo": "ProductPreview-module__2WJK9q__floatTwo",
  "glow": "ProductPreview-module__2WJK9q__glow",
  "googleBadge": "ProductPreview-module__2WJK9q__googleBadge",
  "googleMark": "ProductPreview-module__2WJK9q__googleMark",
  "growBar": "ProductPreview-module__2WJK9q__growBar",
  "headerBadges": "ProductPreview-module__2WJK9q__headerBadges",
  "icon": "ProductPreview-module__2WJK9q__icon",
  "kpiCard": "ProductPreview-module__2WJK9q__kpiCard",
  "kpiGrid": "ProductPreview-module__2WJK9q__kpiGrid",
  "kpiIcon": "ProductPreview-module__2WJK9q__kpiIcon",
  "kpiLabel": "ProductPreview-module__2WJK9q__kpiLabel",
  "kpiMenu": "ProductPreview-module__2WJK9q__kpiMenu",
  "kpiTop": "ProductPreview-module__2WJK9q__kpiTop",
  "kpiValueRow": "ProductPreview-module__2WJK9q__kpiValueRow",
  "main": "ProductPreview-module__2WJK9q__main",
  "mobileBrand": "ProductPreview-module__2WJK9q__mobileBrand",
  "navItem": "ProductPreview-module__2WJK9q__navItem",
  "navLabel": "ProductPreview-module__2WJK9q__navLabel",
  "pageHeader": "ProductPreview-module__2WJK9q__pageHeader",
  "panel": "ProductPreview-module__2WJK9q__panel",
  "panelHeading": "ProductPreview-module__2WJK9q__panelHeading",
  "panelPeriod": "ProductPreview-module__2WJK9q__panelPeriod",
  "performanceRows": "ProductPreview-module__2WJK9q__performanceRows",
  "periodBadge": "ProductPreview-module__2WJK9q__periodBadge",
  "primaryGrid": "ProductPreview-module__2WJK9q__primaryGrid",
  "replyReady": "ProductPreview-module__2WJK9q__replyReady",
  "reviewAvatar": "ProductPreview-module__2WJK9q__reviewAvatar",
  "reviewBody": "ProductPreview-module__2WJK9q__reviewBody",
  "reviewCard": "ProductPreview-module__2WJK9q__reviewCard",
  "reviewFloat": "ProductPreview-module__2WJK9q__reviewFloat",
  "sampleBadge": "ProductPreview-module__2WJK9q__sampleBadge",
  "scoreFloat": "ProductPreview-module__2WJK9q__scoreFloat",
  "sidebar": "ProductPreview-module__2WJK9q__sidebar",
  "sidebarFooter": "ProductPreview-module__2WJK9q__sidebarFooter",
  "stage": "ProductPreview-module__2WJK9q__stage",
  "stars": "ProductPreview-module__2WJK9q__stars",
  "topbar": "ProductPreview-module__2WJK9q__topbar",
  "topbarSpacer": "ProductPreview-module__2WJK9q__topbarSpacer",
  "window": "ProductPreview-module__2WJK9q__window",
  "workspace": "ProductPreview-module__2WJK9q__workspace",
});
